import { useQuery } from "@tanstack/react-query";

import { PatientsAPI } from "../infrastructure/api/patients.api";

/**
 * The student's other courses in which the caller is their mentor too. A
 * training centre keeps one record per course, so each comes with its own.
 */
export function useOtherCourses(patientId: string | undefined, enabled: boolean) {
    const { data } = useQuery({
        queryKey: ["patient-other-courses", patientId],
        queryFn: async () => (await PatientsAPI.otherCourses(patientId as string)).data,
        enabled: enabled && Boolean(patientId),
    });
    return data ?? [];
}
